<template>
    <ui-modal :iconCircle="true"
        name="facebook-accounts-transfer"
        title="Transferência de Integrações"
        size="xs"
        icon="fal fa-repeat-alt"
        colorCircle="icon-danger">
        <div v-if="loader.load" class="load-indicator">
            <div class="load">
                <ui-load-indicator :h="50" :stroke="8" bgColor="#e7e9f4" color="#69D296" />
            </div>
        </div>

        <div v-if="form.dataTransfer" class="transfer">
            <div class="message">
                <p class="title">
                    Existe <b>integrações</b> utilizando a conta que você está tentando
                    desconectar
                </p>

                <p class="subtitle">
                    É necessário transferir essas integrações para outra conta.
                </p>
            </div>

            <div class="caution">
                <span>Cuidado:</span> Essa ação não poderá ser desfeita.
            </div>

            <div class="select-account">
                <form class="form">
                    <ui-select v-model="selected"
                        inline
                        size="lg"
                        textDefault="Selecione conta">
                        <option v-for="select in form.dataTransfer"
                            :key="select.id"
                            :value="select.id">
                            {{ select.name }}
                        </option>
                    </ui-select>
                </form>
            </div>
        </div>

        <ui-alert v-if="form.select"
            name="marketing-integrations-facebook-account-disconnect"
            title="Conta não selecionada"
            text="Para continuar favor selecione uma conta."
            btn-type="danger" />

        <div class="actions">
            <ui-button type="button" class="button-cancelar" design="md mw-100 primary" @click="close">Cancelar</ui-button>

            <ui-button :disabled="disabledSelect"
                design="md mw-100 danger"
                @click="facebookAccountTransfer">
                Transferir
            </ui-button>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiSelect } from '@/components/ui/form'
    import { uiButton } from '@/components/ui/buttons'
    import { uiAlert, uiLoadIndicator } from '@/components/ui'

    import { facebookAccounts } from '@/services/axios'

    export default {
        components: {
            uiModal,
            uiSelect,
            uiButton,
            uiAlert,
            uiLoadIndicator,
        },

        data() {
            return {
                selected: null,
                loader: {
                    load: false
                },
                form: {
                    dataTransfer: null,
                    select: null,
                },
            }
        },

        created() {
            this.$root.$on('list-accounts-modal', (payload) => {
                this.form = { ...payload }
                this.$root.$emit('modal-open-facebook-accounts-transfer')
            })

            this.$root.$on('modal-close-facebook-accounts-transfer', () => {
                this.$root.$emit('modal-open-marketing-integrations-facebook-user-select')
            })

            this.$root.$on('marketing-integrations-facebook-account-now-disconnect-success', () => {
                this.form = null
                this.$root.$emit('datatable-reload-scroll-facebook')
                this.$root.$emit('disconnected-account')
            })
        },

        beforeDestroy() {
            this.$root.$off('list-accounts-modal')
            this.$root.$off('modal-close-facebook-accounts-transfer')
            this.$root.$off('marketing-integrations-facebook-account-now-disconnect-success')
        },

        computed: {
            disabledSelect() {
                return this.selected ? false : true
            },
        },

        methods: {
            facebookAccountTransfer() {
                if (this.selected) {
                    this.$set(this.loader, 'load', true)
                    const params = {
                        transfer_id: this.form.select.id,
                        receive_id: this.selected,
                    }
                    facebookAccounts.transferFacebookForms(params)
                        .then(response => {
                            this.$toastr.s(response.data.msg)
                            this.$set(this.loader, 'load', false)
                            this.$root.$emit('modal-close-facebook-accounts-transfer')
                            this.$root.$emit('datatable-reload-scroll-facebook')
                            this.$root.$emit('datatable-reload-facebook')
                            this.$root.$emit('disconnected-account')
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            console.log(error)
                        })

                } else {
                    this.$root.$emit('alert-msg-open-marketing-integrations-facebook-account-disconnect')
                }
            },
            close() {
                this.$root.$emit('modal-close-facebook-accounts-transfer')
                this.selected = null
            },
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>